module.exports = __webpack_public_path__ + "img/casantino.52f055c2.jpg";